export const REACT_APP_MAP_KEY = 'AIzaSyCVaWxw5YTWJZsTxRNEoP30tj76vJJaLAw';
